/** @format */

import { ChangeDetectionStrategy, Component, PLATFORM_ID, inject, input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

import { Chain } from '@shared/data-access/interfaces';
import { HmfCarouselComponent } from '@dsg-tech/homefield-angular';
import { ProTipsDataService } from './pro-tips-data.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'shared-component-pro-tips',
  templateUrl: './pro-tips.component.html',
  styleUrls: ['./pro-tips.component.scss'],
  imports: [HmfCarouselComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProTipsComponent {
  private readonly proTipsDataService = inject(ProTipsDataService);
  private readonly chain = inject(Chain);
  private readonly platformId = inject(PLATFORM_ID);

  private readonly chainId = this.chain.chainIdentifierAbbr;

  readonly isBrowser = isPlatformBrowser(this.platformId);

  readonly category = input<string>('');

  readonly articleData = toSignal(
    toObservable(this.category).pipe(
      switchMap((category) => this.proTipsDataService.getProTipsData$(category, this.chainId)),
    ),
    { initialValue: [] },
  );

  headerSvg = 'assets/image/dsg/Dicks_ProTips.svg';
  altSvgText = 'DSG PRO TIPS';

  constructor() {
    if (this.chainId === 'gg' || this.chainId === 'pl') {
      this.headerSvg = `assets/image/${this.chainId}/${this.chainId.toUpperCase()}_ProTips.svg`;
      this.altSvgText = `${this.chainId.toUpperCase()} PRO TIPS`;
    }
  }
}
